import { render, staticRenderFns } from "./TicketStatusBadge.vue?vue&type=template&id=0515be8a&scoped=true&"
import script from "./TicketStatusBadge.vue?vue&type=script&lang=js&"
export * from "./TicketStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./TicketStatusBadge.vue?vue&type=style&index=0&id=0515be8a&scoped=true&langs=scss&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0515be8a",
  null
  
)

export default component.exports